// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Fix migliorato per gestire correttamente l'altezza su dispositivi mobili
function setMobileHeight() {
  // Implementa il debouncing per evitare troppe chiamate
  let timeoutId = null;
  
  // Funzione per aggiornare la variabile --vh
  const updateVh = () => {
    // Cancella il timeout precedente se esiste
    if (timeoutId) clearTimeout(timeoutId);
    
    // Imposta un nuovo timeout per il debouncing
    timeoutId = setTimeout(() => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      
      // Log per debug (può essere rimosso in produzione)
      console.log(`Viewport height aggiornata: ${window.innerHeight}px, --vh = ${vh}px`);
    }, 100); // Ritardo di 100ms per il debouncing
  };
  
  // Chiama la funzione subito all'inizio
  updateVh();
  
  // Aggiungi listener per vari eventi che possono modificare l'altezza
  window.addEventListener('resize', updateVh);
  window.addEventListener('orientationchange', updateVh);
  
  // Gestisci specificamente la viewport sui dispositivi mobili (iOS Safari fix)
  if ('visualViewport' in window) {
    window.visualViewport.addEventListener('resize', updateVh);
    window.visualViewport.addEventListener('scroll', updateVh);
  }
  
  // Gestisci eventi specifici per la tastiera virtuale su mobile
  document.addEventListener('focusin', (e) => {
    // Se l'elemento focalizzato è un input o textarea
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
      // Forza l'aggiornamento dell'altezza dopo un breve ritardo
      // per dare tempo alla tastiera di aprirsi completamente
      setTimeout(updateVh, 300);
    }
  });
  
  document.addEventListener('focusout', (e) => {
    // Se l'elemento che perde il focus è un input o textarea
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
      // Aggiorna altezza dopo un breve ritardo
      setTimeout(updateVh, 300);
    }
  });
}

// Esegui quando il documento è caricato
document.addEventListener('DOMContentLoaded', setMobileHeight);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// Registra il service worker per supporto PWA
serviceWorkerRegistration.register();